import React from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Box } from '@mui/material';
import { PayrollPeriodsPage } from './payroll-periods/payroll-periods-page';
import { PayrollEntriesPage } from './payroll-entries/payroll-entries-page';

export function PayrollHomePage() {
    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
            <ReactRouterRoutes>
                <ReactRouterRoute path="/" element={<PayrollPeriodsPage />} />
                <ReactRouterRoute path="/:periodId" element={<PayrollEntriesPage />} />
            </ReactRouterRoutes>
        </Box>
    );
}
